/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuthTokens,
  BuyerEligibilityDto,
  BuyerLocationDto,
  BuyerSignupDto,
  BuyerSummaryDto,
  UpdateBuyerLocationDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * Public. Requires a verified+unconsumed `buyer_signup` OTP for the phone within 10 minutes and a current consent_version_id. Creates a role=buyer user (fica_status=none) and mints tokens. The buyer must then submit KYC (POST /kyc) and be verified before transacting.
 * @summary Buyer self-signup
 */
export const buyersControllerSignup = (
    buyerSignupDto: BuyerSignupDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<AuthTokens>(
      {url: `/buyers/signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: buyerSignupDto, signal
    },
      );
    }
  


export const getBuyersControllerSignupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof buyersControllerSignup>>, TError,{data: BuyerSignupDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof buyersControllerSignup>>, TError,{data: BuyerSignupDto}, TContext> => {

const mutationKey = ['buyersControllerSignup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof buyersControllerSignup>>, {data: BuyerSignupDto}> = (props) => {
          const {data} = props ?? {};

          return  buyersControllerSignup(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BuyersControllerSignupMutationResult = NonNullable<Awaited<ReturnType<typeof buyersControllerSignup>>>
    export type BuyersControllerSignupMutationBody = BuyerSignupDto
    export type BuyersControllerSignupMutationError = unknown

    /**
 * @summary Buyer self-signup
 */
export const useBuyersControllerSignup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof buyersControllerSignup>>, TError,{data: BuyerSignupDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof buyersControllerSignup>>,
        TError,
        {data: BuyerSignupDto},
        TContext
      > => {

      const mutationOptions = getBuyersControllerSignupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Buyer-only. Returns ficaStatus + canTransact so the client can pre-gate UI before hitting a 403 buyer_kyc_required on a write action.
 * @summary Buyer transaction eligibility
 */
export const buyersControllerEligibility = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<BuyerEligibilityDto>(
      {url: `/buyers/me/eligibility`, method: 'GET', signal
    },
      );
    }
  



export const getBuyersControllerEligibilityQueryKey = () => {
    return [
    `/buyers/me/eligibility`
    ] as const;
    }

    
export const getBuyersControllerEligibilityQueryOptions = <TData = Awaited<ReturnType<typeof buyersControllerEligibility>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerEligibility>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBuyersControllerEligibilityQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof buyersControllerEligibility>>> = ({ signal }) => buyersControllerEligibility(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof buyersControllerEligibility>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BuyersControllerEligibilityQueryResult = NonNullable<Awaited<ReturnType<typeof buyersControllerEligibility>>>
export type BuyersControllerEligibilityQueryError = unknown


export function useBuyersControllerEligibility<TData = Awaited<ReturnType<typeof buyersControllerEligibility>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerEligibility>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof buyersControllerEligibility>>,
          TError,
          Awaited<ReturnType<typeof buyersControllerEligibility>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBuyersControllerEligibility<TData = Awaited<ReturnType<typeof buyersControllerEligibility>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerEligibility>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof buyersControllerEligibility>>,
          TError,
          Awaited<ReturnType<typeof buyersControllerEligibility>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBuyersControllerEligibility<TData = Awaited<ReturnType<typeof buyersControllerEligibility>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerEligibility>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Buyer transaction eligibility
 */

export function useBuyersControllerEligibility<TData = Awaited<ReturnType<typeof buyersControllerEligibility>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerEligibility>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBuyersControllerEligibilityQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Buyer-only. Read-only aggregate over the buyer's own orders (orders placed, settled count, total spent across settled orders as micro-ZARP, and a per-status breakdown). Powers the buyer Account hub stat-grid. The watchlist count is client-only and not included here.
 * @summary Buyer account summary
 */
export const buyersControllerSummary = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<BuyerSummaryDto>(
      {url: `/buyers/me/summary`, method: 'GET', signal
    },
      );
    }
  



export const getBuyersControllerSummaryQueryKey = () => {
    return [
    `/buyers/me/summary`
    ] as const;
    }

    
export const getBuyersControllerSummaryQueryOptions = <TData = Awaited<ReturnType<typeof buyersControllerSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBuyersControllerSummaryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof buyersControllerSummary>>> = ({ signal }) => buyersControllerSummary(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof buyersControllerSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BuyersControllerSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof buyersControllerSummary>>>
export type BuyersControllerSummaryQueryError = unknown


export function useBuyersControllerSummary<TData = Awaited<ReturnType<typeof buyersControllerSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof buyersControllerSummary>>,
          TError,
          Awaited<ReturnType<typeof buyersControllerSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBuyersControllerSummary<TData = Awaited<ReturnType<typeof buyersControllerSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof buyersControllerSummary>>,
          TError,
          Awaited<ReturnType<typeof buyersControllerSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBuyersControllerSummary<TData = Awaited<ReturnType<typeof buyersControllerSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Buyer account summary
 */

export function useBuyersControllerSummary<TData = Awaited<ReturnType<typeof buyersControllerSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerSummary>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBuyersControllerSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Buyer-only. Returns the caller's OWN stored WGS84 point (their data, for the location-capture UI), or null when unset. Used server-side only to derive coarse distance bands on listings — a seller never sees these coordinates.
 * @summary Read the buyer's own location
 */
export const buyersControllerGetLocation = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<BuyerLocationDto>(
      {url: `/buyers/me/location`, method: 'GET', signal
    },
      );
    }
  



export const getBuyersControllerGetLocationQueryKey = () => {
    return [
    `/buyers/me/location`
    ] as const;
    }

    
export const getBuyersControllerGetLocationQueryOptions = <TData = Awaited<ReturnType<typeof buyersControllerGetLocation>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerGetLocation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBuyersControllerGetLocationQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof buyersControllerGetLocation>>> = ({ signal }) => buyersControllerGetLocation(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof buyersControllerGetLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type BuyersControllerGetLocationQueryResult = NonNullable<Awaited<ReturnType<typeof buyersControllerGetLocation>>>
export type BuyersControllerGetLocationQueryError = unknown


export function useBuyersControllerGetLocation<TData = Awaited<ReturnType<typeof buyersControllerGetLocation>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerGetLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof buyersControllerGetLocation>>,
          TError,
          Awaited<ReturnType<typeof buyersControllerGetLocation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBuyersControllerGetLocation<TData = Awaited<ReturnType<typeof buyersControllerGetLocation>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerGetLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof buyersControllerGetLocation>>,
          TError,
          Awaited<ReturnType<typeof buyersControllerGetLocation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useBuyersControllerGetLocation<TData = Awaited<ReturnType<typeof buyersControllerGetLocation>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerGetLocation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Read the buyer's own location
 */

export function useBuyersControllerGetLocation<TData = Awaited<ReturnType<typeof buyersControllerGetLocation>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof buyersControllerGetLocation>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getBuyersControllerGetLocationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Buyer-only. Stores the caller's location at full WGS84 precision for the marketplace "near me" distance bands. `location: null` clears it. The point is never exposed to sellers; listings only ever carry a coarse distanceBand derived from it.
 * @summary Set or clear the buyer's location
 */
export const buyersControllerSetLocation = (
    updateBuyerLocationDto: UpdateBuyerLocationDto,
 ) => {
      
      
      return fseAxios<BuyerLocationDto>(
      {url: `/buyers/me/location`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateBuyerLocationDto
    },
      );
    }
  


export const getBuyersControllerSetLocationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof buyersControllerSetLocation>>, TError,{data: UpdateBuyerLocationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof buyersControllerSetLocation>>, TError,{data: UpdateBuyerLocationDto}, TContext> => {

const mutationKey = ['buyersControllerSetLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof buyersControllerSetLocation>>, {data: UpdateBuyerLocationDto}> = (props) => {
          const {data} = props ?? {};

          return  buyersControllerSetLocation(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BuyersControllerSetLocationMutationResult = NonNullable<Awaited<ReturnType<typeof buyersControllerSetLocation>>>
    export type BuyersControllerSetLocationMutationBody = UpdateBuyerLocationDto
    export type BuyersControllerSetLocationMutationError = unknown

    /**
 * @summary Set or clear the buyer's location
 */
export const useBuyersControllerSetLocation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof buyersControllerSetLocation>>, TError,{data: UpdateBuyerLocationDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof buyersControllerSetLocation>>,
        TError,
        {data: UpdateBuyerLocationDto},
        TContext
      > => {

      const mutationOptions = getBuyersControllerSetLocationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    